import { useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useParams } from "react-router-dom";
import Loader from "../components/shared/Loader";
import { useGetPaymentSDKQuery } from "../store/services/PaymentService";

export default function RedirectSDKPage() {

    const { id } = useParams();
    const { data, isLoading } = useGetPaymentSDKQuery(id ? id : skipToken);

    let urlRedirect = data?.payment?.cancelUrl;

    useEffect(() => {
        if (!isLoading) {
            setInterval(() => {
                window.postMessage('FNM_CANCEL', '*');
                if((window as any).webkit && (window as any).webkit.messageHandlers) (window as any).webkit.messageHandlers.paymentOutcomeHandler.postMessage("FNM_CANCEL")
                if((window as any).ReactNativeWebview) (window as any).ReactNativeWebview.postMessage('FNM_CANCEL', '*')
                window.location.href = urlRedirect;   
            }, 1000);
        }
    }, [urlRedirect, isLoading])

    return (
        <Loader />
    )
}